import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const borderRadiusHeight = spacing(3)

export const backButton = css`
  inset-block-end: calc(${spacing(1.5)} + ${borderRadiusHeight});
  position: absolute;
  inset-inline-start: ${spacing(1.5)};
  z-index: 1;
`

export const map = css`
  block-size: 100%;
  inline-size: 100%;
  position: relative;
`

export const pinContainer = css`
  block-size: ${spacing(9)}; // 72px
  inline-size: ${spacing(8.25)}; // 66px
  position: relative;
`

// Пин в яндекс-картах ставится в координату левым верхним углом,
// поэтому само изображение перемещаем в этот левый верхний угол
export const pin = css`
  inset-inline-start: -50%;
  inset-block-start: -80%; // 80%, чтобы хвостик пина оказался на координате точке
  position: absolute;
  transform: translate(50% 50%);
`

export const pinOrderNum = css`
  block-size: ${spacing(3.75)} !important;
  inline-size: ${spacing(3.75)} !important;
  inset-block-start: ${spacing(1.5)};
  inset-inline-start: ${spacing(2.25)};
  position: absolute;
`
